<template>
    <div>
    <Btn type="button"  @onClick="toggleEmployeeModal" >
          {{ ___("Invitation|Manage Employees|content") }}
    </Btn>
    <Modal v-if="showEmployeeModal" @close="toggleEmployeeModal" class="text-black"  width="max-w-full">
      <template v-slot:header>
        <h3 class="text-subheader-font-size font-semibold">{{ ___("Invitation|Manage Employees|content") }}</h3>
      </template>

      <template v-slot:body>
        <div class="flex flex-wrap">
          <div class="w-full">
            <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
              <li class="-mb-px mr-2 last:mr-0 flex-auto text-center">
                <a class="font-bold uppercase px-5 py-3 shadow-lg rounded-customRadius block leading-normal headline cursor-pointer text-tab-font-size"
                  v-on:click="toggleTabs(1)" v-bind:class="{
                    'bg-white text-primary-hover-text-color':
                      openTab !== 1,
                    'bg-primary-color text-primary-text-color':
                      openTab === 1,
                  }">
                  {{ ___("Invitation|Employees|content") }}
                </a>
              </li>
              <li class="-mb-px mr-2 last:mr-0 flex-auto text-center" v-if="$page.props.user.allow_invitation">
                <a class="font-bold uppercase px-5 py-3 shadow-lg rounded-customRadius block leading-normal headline cursor-pointer text-tab-font-size"
                  v-on:click="toggleTabs(2)" v-bind:class="{
                    'bg-white text-primary-hover-text-color':
                      openTab !== 2,
                    'bg-primary-color text-primary-text-color':
                      openTab === 2,
                  }">
                  {{ ___("Invitation|Invite|content") }}
                </a>
              </li>
            </ul>
            <div class="relative flex flex-col min-w-0 break-words bg-white w-full shadow-lg rounded">
              <div class="px-4 py-5 flex-auto ">
                <div class="tab-content tab-space">
                  <div v-bind:class="{
                    hidden: openTab !== 1,
                    block: openTab === 1,
                  }">

                    <Btn class="mb-5" type="button" @onClick="sendPendingInvitationReminder">
                      {{ ___("Invitation|Send Pending Invitation Reminder|content") }}
                    </Btn>

                  <div>
                    <h3 class="text-subheader-font-size font-semibold">   {{ ___("Invitation|Sub accounts|content") }} </h3>
                  <div v-if=" $page.props.userSubAccount.length>0">
                    <div class="overflow-x-scroll scrollbar">
                      <table class="border-collapse w-full table-auto" >
                        <thead class="text-left">
                          <tr>
                            <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|Name|content") }}</th>
                            <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|Job Position|content") }}</th>
                            <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("General|Email|content") }}</th>
                          <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|Can see article price|content") }}</th>
                          <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">
                          {{ ___("Invitation|Can see quotation|content") }}
                        </th>
                            <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|Status of invited|content") }}</th>
                            <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|Status of accepted|content") }}</th>
                            <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|De Activate account|content") }}</th>
                          <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          " v-if="$page.props.user.helpdesk_enabled">{{ ___("Invitation|De Activate Helpdesk|content") }}</th>
                          <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|Show Orders View|content") }}</th>
                          <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|Show Shipment View|content") }}</th>
                          <th class="
                            p-2
                            capitalize
                            text-black
                            border border-primary-color
                            hidden
                            lg:table-cell
                            w-60
                            cursor-pointer
                          ">{{ ___("Invitation|Show Invoice View|content") }}</th>
                        </tr>

                        </thead>
                        <tbody>
                          <tr
                            v-for="(subAccount, index) in $page.props.userSubAccount" :key="index"
                          class="
                            shadow-md
                            lg:shadow-none
                            hover:bg-gray-300
                            bg-white
                            border border-b
                            flex
                            lg:table-row
                            flex-row
                            lg:flex-row
                            flex-wrap
                            lg:flex-no-wrap
                            mb-2
                            lg:mb-0
                          "
                        >
                            <td
                              class="
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                block
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Name|content") }} :</span
                              >
                              {{ subAccount.name }}
                            </td>
                            <td
                              class="
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                block
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Job Position|content") }} :</span>{{subAccount.job_position}}
                            </td>
                            <td
                              class="
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                block
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("General|Email|content") }}  : </span>{{ subAccount.email }}
                            </td>
                            <td
                              class="
                                w-full
                                md:w-auto
                                inline-flex
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                block
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Can see article price|content") }} : </span> <span class="capitalize">
                                <svg v-if="subAccount.show_article_prices == true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#68D391" class="w-6 h-6 mx-auto">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#e14242" class="w-6 h-6 mx-auto	">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                              </span>
                            </td>
                            <td  class="
                                w-full
                                md:w-auto
                                inline-flex
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                block
                                lg:table-cell
                                relative
                                lg:static
                              ">
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Can see quotation|content") }} : </span>
                                <svg v-if="subAccount.show_quotation == true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#68D391" class="w-6 h-6 mx-auto">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#e14242" class="w-6 h-6 mx-auto	">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </td>
                            <td
                              class="
                                w-full
                                inline-flex
                                md:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                block
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Status of invited|content") }}  :
                            </span>
                                <svg v-if="subAccount.invitation_sent == 0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#e14242"  class="w-6 h-6 mx-auto">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                                <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#68D391" class="w-6 h-6 mx-auto">
                                  <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                                </svg>
                            </td>
                            <td
                              class="
                              inline-flex
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                block
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Status of accepted|content") }}  : </span>
                              <span v-if="subAccount.invitation_sent ==1 && subAccount.activated ==0">
                                  <Btn type="button" @onClick="resendInvitation(subAccount.id)">
                                  {{ ___("Invitation|Resend Invitation|content") }}
                                </Btn>
                              </span>
                              <svg v-else-if="subAccount.activated ==0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#e14242" class="w-6 h-6 mx-auto">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                              </svg>
                              <svg  v-else-if="subAccount.activated ==1" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="#68D391" class="w-6 h-6 mx-auto">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
                              </svg>
                            </td>
                            <td
                              class="
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                flex items-center
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|De Activate account|content") }} :</span
                              >
                              <span
                                  class="w-15 h-8 p-1 flex items-center bg-black rounded-customRadius duration-300 cursor-pointer lg:mx-auto ml-2"
                                  :class="{'bg-primary-color': subAccount.activated }" :aria-checked="subAccount.activated.toString()" @click="toggleActivation(subAccount,'sub_account')">
                                  <span class="bg-white w-6 h-6 rounded-customRadius shadow-md transform duration-300"
                                    :class="{
                                      'translate-x-6':
                                      subAccount.activated ,
                                    }"></span>
                              </span>
                            </td>
                            <td
                              class="
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                flex items-center
                                lg:table-cell
                                relative
                                lg:static
                              "
                              v-if="$page.props.user.helpdesk_enabled"
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|De Activate Helpdesk|content") }} :</span
                              >
                              <span
                                  class="w-15 h-8 p-1 flex items-center bg-black rounded-customRadius duration-300 cursor-pointer lg:mx-auto ml-2"
                                  :class="{'bg-primary-color': subAccount.helpdesk_enabled }" :aria-checked="subAccount.helpdesk_enabled.toString()" @click="toggleHelpdesk(subAccount)">
                                  <span class="bg-white w-6 h-6 rounded-customRadius shadow-md transform duration-300"
                                    :class="{
                                      'translate-x-6':
                                      subAccount.helpdesk_enabled ,
                                    }"></span>
                              </span>
                            </td>
                            <td
                              class="
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                flex items-center
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Show Orders View|content") }} :</span
                              >
                              <span
                                  class="w-15 h-8 p-1 flex items-center bg-black rounded-customRadius duration-300 cursor-pointer lg:mx-auto ml-2"
                                  :class="{'bg-primary-color': subAccount.show_order_view }" :aria-checked="subAccount.show_order_view.toString()" @click="toggleView(subAccount,'show_order_view')">
                                  <span class="bg-white w-6 h-6 rounded-customRadius shadow-md transform duration-300"
                                    :class="{
                                      'translate-x-6':
                                      subAccount.show_order_view ,
                                    }"></span>
                              </span>
                            </td>
                            <td
                              class="
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                flex items-center
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Show Shipment View|content") }} :</span
                              >
                              <span
                                  class="w-15 h-8 p-1 flex items-center bg-black rounded-customRadius duration-300 cursor-pointer lg:mx-auto ml-2"
                                  :class="{'bg-primary-color': subAccount.show_shipment_view }" :aria-checked="subAccount.show_shipment_view.toString()" @click="toggleView(subAccount,'show_shipment_view')">
                                  <span class="bg-white w-6 h-6 rounded-customRadius shadow-md transform duration-300"
                                    :class="{
                                      'translate-x-6':
                                      subAccount.show_shipment_view ,
                                    }"></span>
                              </span>
                            </td>
                            <td
                              class="
                                w-full
                                lg:w-auto
                                p-2
                                text-gray-800
                                lg:text-center lg:border lg:border-b
                                flex items-center
                                lg:table-cell
                                relative
                                lg:static
                              "
                            >
                              <span
                                class="lg:hidden text-gray-600 font-bold capitalize"
                              >
                              {{ ___("Invitation|Show Invoice View|content") }} :</span
                              >
                              <span
                                  class="w-15 h-8 p-1 flex items-center bg-black rounded-customRadius duration-300 cursor-pointer lg:mx-auto ml-2"
                                  :class="{'bg-primary-color': subAccount.show_invoice_view }" :aria-checked="subAccount.show_invoice_view.toString()" @click="toggleView(subAccount,'show_invoice_view')">
                                  <span class="bg-white w-6 h-6 rounded-customRadius shadow-md transform duration-300"
                                    :class="{
                                      'translate-x-6':
                                      subAccount.show_invoice_view ,
                                    }"></span>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div v-if="valueChanged" class="text-white p-2 border-0 rounded relative bg-red-600 w-full align-middle mt-2">
                      <svg class="inline flex-shrink-0 mr-3 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      <span class="inline-block align-middle mr-8">
                        <b class="capitalize"> {{ ___("Invitation|Alert|content") }}!</b>
                        {{ ___("Invitation|Alert Message|content") }}
                      </span>
                    </div>
                    <Btn class="mt-2" @onClick="saveChanges('sub_account')" :disabled="!valueChanged" :class="{ 'cursor-not-allowed	': !valueChanged }">{{ ___("Invitation|Save changes|content") }}</Btn>
                  </div>
                  <p  class="text-subheader-font-size subline p-6" v-else>
                    {{ ___("Invitation|No accounts linked|content") }}
                  </p>
                  </div>

                  <div class="my-5" v-if="$page.props.isPersonWeclappAccountInvitationEnabled">
                    <h3 class="text-xl font-semibold">{{ ___("Invitation|Person accounts|content") }} </h3>
                    <div v-if=" $page.props.userPersonAccount.length>0">
                      <div class="overflow-x-scroll scrollbar">
                        <table class="border-collapse w-full table-auto" >
                          <thead class="text-left">
                            <tr>
                              <th class="
                              p-2
                              capitalize
                              text-black
                              border border-primary-color
                              hidden
                              lg:table-cell
                              w-60
                              cursor-pointer
                            ">{{ ___("Invitation|Name|content") }}</th>
                            <th class="
                              p-2
                              capitalize
                              text-black
                              border border-primary-color
                              hidden
                              lg:table-cell
                              w-60
                              cursor-pointer
                            ">{{ ___("General|Email|content") }}</th>
                            <th class="
                              p-2
                              capitalize
                              text-black
                              border border-primary-color
                              hidden
                              lg:table-cell
                              w-60
                              cursor-pointer
                            ">{{ ___("Invitation|De Activate account|content") }}</th>
                            <th v-if="$page.props.personAttributes['attribute1']['isShown']" class="
                              p-2
                              capitalize
                              text-black
                              border border-primary-color
                              hidden
                              lg:table-cell
                              w-60
                              cursor-pointer
                            ">{{($page.props.personAttributes['attribute1']['header']) }}
                            </th>
                            <th v-if="$page.props.personAttributes['attribute2']['isShown']" class="
                              p-2
                              capitalize
                              text-black
                              border border-primary-color
                              hidden
                              lg:table-cell
                              w-60
                              cursor-pointer
                            ">{{($page.props.personAttributes['attribute2']['header']) }}</th>
                             <th v-if="$page.props.personAttributes['attribute3']['isShown']" class="
                              p-2
                              capitalize
                              text-black
                              border border-primary-color
                              hidden
                              lg:table-cell
                              w-60
                              cursor-pointer
                            ">{{($page.props.personAttributes['attribute3']['header']) }}</th>
                          </tr>
                         

                          </thead>
                          <tbody>
                            <tr
                              v-for="(personAccount, pindex) in $page.props.userPersonAccount" :key="pindex"
                            class="
                              shadow-md
                              lg:shadow-none
                              hover:bg-gray-300
                              bg-white
                              border border-b
                              flex
                              lg:table-row
                              flex-row
                              lg:flex-row
                              flex-wrap
                              lg:flex-no-wrap
                              mb-2
                              lg:mb-0
                            "
                          >
                              <td
                                class="
                                  w-full
                                  lg:w-auto
                                  p-2
                                  text-gray-800
                                  lg:text-center lg:border lg:border-b
                                  block
                                  lg:table-cell
                                  relative
                                  lg:static
                                "
                              >
                                <span
                                  class="lg:hidden text-gray-600 font-bold capitalize"
                                >
                                {{ ___("Invitation|Name|content") }} :</span
                                >
                                {{ personAccount.name }}
                              </td>
                              <td
                                class="
                                  w-full
                                  lg:w-auto
                                  p-2
                                  text-gray-800
                                  lg:text-center lg:border lg:border-b
                                  block
                                  lg:table-cell
                                  relative
                                  lg:static
                                "
                              >
                                <span
                                  class="lg:hidden text-gray-600 font-bold capitalize"
                                >
                                {{ ___("General|Email|content") }}  : </span>{{ personAccount.email }}
                              </td>
                              <td
                                class="
                                  w-full
                                  lg:w-auto
                                  p-2
                                  text-gray-800
                                  lg:text-center lg:border lg:border-b
                                  flex items-center
                                  lg:table-cell
                                  relative
                                  lg:static
                                "
                              >
                                <span
                                  class="lg:hidden text-gray-600 font-bold capitalize"
                                >
                                {{ ___("Invitation|De Activate account|content") }}:</span
                                >
                                <span
                                    class="w-15 h-8 p-1 flex items-center bg-black rounded-customRadius duration-300 cursor-pointer lg:mx-auto ml-2"
                                    :class="{'bg-primary-color': personAccount.activated }" :aria-checked="personAccount.activated.toString()" @click="toggleActivation(personAccount,'person_account')">
                                    <span class="bg-white w-6 h-6 rounded-customRadius shadow-md transform duration-300"
                                      :class="{
                                        'translate-x-6':
                                        personAccount.activated ,
                                      }"></span>
                                </span> 
                              </td>
                              <td v-if="$page.props.personAttributes['attribute1']['isShown']"  class="
                                  w-full
                                  lg:w-auto
                                  p-2
                                  text-gray-800
                                  lg:text-center lg:border lg:border-b
                                  flex items-center
                                  lg:table-cell
                                  relative
                                  lg:static
                                ">{{ getCustomAttributeValue(personAccount.crm_data['customAttributes'],$page.props.personAttributes['attribute1']['key'])}}</td>
                                <td v-if="$page.props.personAttributes['attribute2']['isShown'] "  class="
                                  w-full
                                  lg:w-auto
                                  p-2
                                  text-gray-800
                                  lg:text-center lg:border lg:border-b
                                  flex items-center
                                  lg:table-cell
                                  relative
                                  lg:static
                                ">{{ getCustomAttributeValue(personAccount.crm_data['customAttributes'],$page.props.personAttributes['attribute2']['key'])}}</td>
                                <td v-if="$page.props.personAttributes['attribute3']['isShown']"  class="
                                  w-full
                                  lg:w-auto
                                  p-2
                                  text-gray-800
                                  lg:text-center lg:border lg:border-b
                                  flex items-center
                                  lg:table-cell
                                  relative
                                  lg:static
                                ">{{ getCustomAttributeValue(personAccount.crm_data['customAttributes'],$page.props.personAttributes['attribute3']['key'])}}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                     <div v-if="valueChangedPerson" class="text-white p-2 border-0 rounded relative bg-red-600 w-full align-middle mt-2">
                      <svg class="inline flex-shrink-0 mr-3 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path
                          fill-rule="evenodd"
                          d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                          clip-rule="evenodd"
                        ></path>
                      </svg>
                      <span class="inline-block align-middle mr-8">
                        <b class="capitalize"> {{ ___("Invitation|Alert|content") }}!</b>
                        {{ ___("Invitation|Alert Message|content") }}
                      </span>
                    </div>
                    
                    <Btn class="mt-2" @onClick="saveChanges('person_account')" :disabled="!valueChangedPerson" :class="{ 'cursor-not-allowed	': !valueChangedPerson }">{{ ___("Invitation|Save changes|content") }}</Btn> 
                  </div>
                  <p  class="text-subheader-font-size subline p-6" v-else>
                    {{ ___("Invitation|No accounts linked|content") }}
                  </p>
                  </div>

                  </div>
                  <div v-if="$page.props.user.allow_invitation" v-bind:class="{
                    hidden: openTab !== 2,
                    block: openTab === 2, 
                  }">

                  <Btn @onClick="csvUpload" >CSV upload</Btn>

                    <form action=""  @submit.prevent="submit" class="mt-5">
                      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div v-if="$page.props.isPersonWeclappAccountInvitationEnabled">
                          <label class="field-label" for="account_type">{{ ___("Invitation|Account type|content") }}:</label>
                          <div class="relative text-gray-700">
                            <select
                              v-model="form.account_type"
                              class="
                              block
                                appearance-none
                                w-full
                                bg-transparent
                                border
                                py-2 px-3
                                pr-10
                                rounded
                                leading-tight
                                focus:outline-none
                                cursor-pointer border-gray-300
                              "
                              id="account_type"
                              @change="clearJobPostion()"
                            >
                              <option value="sub_account" class="text-gray-700">
                                {{ ___("Invitation|Sub account|content") }}
                              </option>
                              <option value="person_account"  class="text-gray-700">
                                {{ ___("Invitation|Person account|content") }}
                              </option>
                            </select>
                            <div
                              class="
                                pointer-events-none
                                absolute
                                inset-y-0
                                right-0
                                flex
                                items-center
                                px-2
                                placeholder-menu-text-color
                                border-menu-text-color
                              "
                            >
                              <svg
                                class="fill-current h-4 w-4"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 20 20"
                              >
                                <path
                                  d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                />
                              </svg>
                            </div>
                          </div>
                        </div>
                        <div>
                          <label class="field-label" for="firstname">{{ ___("Invitation|First Name|content") }}:</label>
                          <input
                            class="field appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                            id="firstname" type="text" v-model="form.firstname" :placeholder="___('Invitation|First Name|content')" />
                        </div>
                        <div>
                          <label class="field-label" for="lastname">{{ ___("Invitation|Last Name|content") }}:</label>
                          <input
                            class="field appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                            id="lastname" type="text" v-model="form.lastname" :placeholder="___('Invitation|Last Name|content')" />
                        </div>
                        <div v-if="form.account_type == 'sub_account'">
                          <label class="field-label" for="jobposition">{{ ___("Invitation|Job Position|content") }}:</label>
                          <input
                            class="field appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                            id="jobposition" type="text" v-model=" form.jobposition" :placeholder="___('Invitation|Job Position|content')" />
                        </div>
                        <div class="relative group">
                          <label class="field-label" for="email">{{ ___("General|Email|content") }}:</label>
                          <input
                            class="field appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none"
                            :disabled="emailCheck"
                            id="email" type="email" v-model="form.email" :placeholder="___('General|Email|content')" />
                          <div class="absolute bottom-0 right-0 flex flex-col items-center hidden mb-6 group-hover:flex ">
                              <p class="relative z-10 p-2 text-xs leading-none text-white whitespace-no-wrap bg-black shadow-lg">
                                {{ ___("Invitation|Valid Domains|content") }} : {{validEmails.join(', ')}}
                              </p>
                              <div class="w-3 h-3 -mt-2 mr-1 transform rotate-45 bg-black"></div>
                            </div>
                        </div>
                        <template v-if="form.account_type == 'person_account'">
                          <div v-for="(customAttribute,c) in customAttributeForm" :key="c">

                          <label class="field-label" :for="customAttribute.attributeDefinitionId ">{{ customAttribute.label }}:</label>
                          <input
                            class="py-3 px-4 pr-8 mt-3 block"
                            v-if="customAttribute.attributeType == 'BOOLEAN'"
                            type="checkbox"
                            :id="customAttribute.attributeDefinitionId"
                            :name="customAttribute.attributeDefinitionId"
                            v-model="customAttribute.booleanValue"
                          />
                          <input
                              v-if="
                                customAttribute.attributeType == 'STRING' ||
                                customAttribute.attributeType == 'LARGE_TEXT' ||
                                customAttribute.attributeType == 'URL'
                              "
                              class="
                                field
                                appearance-none
                                border
                                rounded
                                w-full
                                py-3
                                px-4
                                pr-8
                                text-gray-700
                                leading-tight
                                focus:outline-none
                              "
                              :name="customAttribute.attributeDefinitionId"
                              :id="customAttribute.attributeDefinitionId"
                              :placeholder="customAttribute.label"
                              v-model="customAttribute.stringValue"
                            />
                            <input
                              class="
                                field
                                appearance-none
                                border
                                rounded
                                w-full
                                py-3
                                px-4
                                pr-8
                                text-gray-700
                                leading-tight
                                focus:outline-none
                              "
                              v-if="
                                customAttribute.attributeType == 'INTEGER' ||
                                customAttribute.attributeType == 'DECIMAL'
                              "
                              type="number"
                              :id="customAttribute.attributeDefinitionId"
                              :name="customAttribute.attributeDefinitionId"
                              v-model="customAttribute.numberValue"
                              :step="customAttribute.attributeType == 'DECIMAL' ? '.01' : '1'"
                              :placeholder="customAttribute.label"
                            /> 

                            <div v-if="customAttribute.attributeType == 'MULTISELECT_LIST'">
                              <multiselect
                              class="text-base"
                                :options="customAttribute.selectableValues"
                                :multiple="true"
                                :clear-on-select="false"
                                :preserve-search="true"
                                :placeholder="___('General|Select options|content')"
                                :selectLabel="___('General|Press enter to select|content')"
                                :deselectLabel="___('General|Press enter to remove|content')"
                                :selectedLabel="___('General|Selected|content')"
                                label="value"
                                track-by="value"
                                v-model="
                                  customAttribute.selectedValues
                                "
                              >
                                <template slot="noResult">
                                  {{ ___("General|MultiSelectError|content") }}
                                </template>
                                <template slot="noOptions">
                                    {{ ___("General|No Options|content") }}
                                  </template>
                                <template
                                  class="py-3 px-4 pr-8"
                                  slot="selection"
                                  slot-scope="{ values, isOpen }"
                                  ><span
                                    class="multiselect__single"
                                    v-if="values.length &amp;&amp; !isOpen"
                                    >{{ values.length }} {{ ___("General|Options selected|content") }}</span
                                  ></template
                                >
                              </multiselect>
                              <p class="mt-2">
                                {{ valueString(customAttribute.selectedValues)}}
                              </p>
                            </div>
                            <div class="relative" v-if="customAttribute.attributeType == 'LIST'">
                              <select
                                class="
                                  block
                                  appearance-none
                                  w-full
                                  bg-white
                                  border border-gray-200
                                  text-gray-700
                                  py-3
                                  px-4
                                  pr-8
                                  rounded
                                  leading-tight
                                  focus:outline-none focus:border-gray-500
                                "
                                :name="customAttribute.attributeDefinitionId"
                                id="grid-state"
                                v-model="
                                  customAttribute.selectedValueId
                                "
                                :placeholder="___('General|Select options|content')"
                              >
                                <option
                                  v-for="(value, j) in customAttribute.selectableValues"
                                  :key="j"
                                  :value="value.id"
                                >
                                  {{ value.value }}
                                </option>
                              </select>
                              <div
                                class="
                                  pointer-events-none
                                  absolute
                                  inset-y-0
                                  right-0
                                  flex
                                  items-center
                                  px-2
                                  text-gray-700
                                "
                              >
                                <svg
                                  class="fill-current h-4 w-4"
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 20 20"
                                >
                                  <path
                                    d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                                  />
                                </svg>
                              </div>
                            </div>
                            <input
                              class="
                                field
                                appearance-none
                                border
                                rounded
                                w-full
                                py-3
                                px-4
                                pr-8
                                text-gray-700
                                leading-tight
                                focus:outline-none
                                cursor-pointer
                              "
                              v-if="customAttribute.attributeType == 'DATE'"
                              type="date"
                              :id="customAttribute.attributeDefinitionId"
                              :name="customAttribute.attributeDefinitionId"
                              v-model="customAttribute.dateValue"
                            />
                          </div>
                        </template>

                      </div>
                      <div v-if="!isemailvalid && form.email" class="p-4 my-4 text-sm text-red-700 bg-red-100 rounded-lg" role="alert">
                        <span class="font-bold">{{ ___("Invitation|Error|content") }}!</span>
                        {{ ___("Invitation|Error Message|content") }}
                      </div>

                      <div v-if="errors.length" class="p-4 my-4 text-sm text-red-700 bg-red-100 rounded-lg">
                        <b>{{ ___("Invitation|Error|content") }}</b>
                        <ul class="list-disc list-inside">
                          <li v-for="error in errors" :key="error.id">{{ error }}</li>
                        </ul>
                      </div>

                      <div class="mt-2">
                        <Btn type="button" @onClick="inviteAccount">
                          {{ ___("Invitation|Invite|content") }}
                        </Btn>
                        <Btn type="button" @onClick="clearForm">
                          {{ ___("Invitation|Clear|content") }}
                        </Btn>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Modal>
    <ConfirmationMessage :isAlertShown="isAlertShown" :alertType="invitationStatus" class="z-20">
      <template v-if="invitationStatus == 'Success'" v-slot:alert>
        {{ ___("Invitation|Invitation Alert|content") }}!
      </template>
      <template v-else v-slot:alert>
       {{ ___("Invitation|Invitation Error Alert|content") }}!
      </template>
      <template v-if="invitationStatus == 'Success'" v-slot:body>
        {{ ___("Invitation|Invitation Body|content") }}
      </template>
      <template v-else v-slot:body>
        {{ ___("Invitation|Invitation Error Body|content") }}
      </template>
    </ConfirmationMessage>

    <ConfirmationMessage :isAlertShown="isResendInvitationShown" :alertType="resendinvitationStatus" class="z-20">
      <template v-if="resendinvitationStatus == 'Success'" v-slot:alert>
        {{ ___("Invitation|Invitation Alert|content") }}!
      </template>
      <template v-else v-slot:alert>
       {{ ___("Invitation|Invitation Error Alert|content") }}!
      </template>
      <template v-if="resendinvitationStatus == 'Success'" v-slot:body>
        {{ ___("Invitation|Reinvitation Body|content") }}
      </template>
      <template v-else v-slot:body>
        {{ ___("Invitation|Reinvitation Error Body|content") }}
      </template>
    </ConfirmationMessage>

    <Modal v-if="showCsvModal" @close="toggleCsvUploadModal" class="text-black"  width="max-w-full">
      <template v-slot:header>
        <h3 class="text-subheader-font-size font-semibold"> {{ ___("Invitation|CSV Upload|content") }}</h3>
      </template>

      <template v-slot:body >
        <div class="flex justify-between">
          <div>
            <p>{{ ___("Invitation|Type of accounts to be invited|content") }} :</p>
          <label>
            <input type="radio" value="subAccount" v-model="selectedCSVType" @change="updateCsvType()"> {{ ___("Invitation|Sub account|content") }}
          </label>

          <label>
            <input type="radio" value="personAccount" v-model="selectedCSVType" @change="updateCsvType()">{{ ___("Invitation|Person account|content") }}
          </label>
          </div>
          <Btn @onClick="downloadTemplate"> {{ ___("Invitation|Download Template|content", { type: selectedCSVType }) }}</Btn>
        </div>
        <div class="mt-5" v-if="isUploadEnabled">
          <h3 class="font-semibold">{{ ___("Invitation|Upload file for validation|content") }}</h3>
          <input class="block mt-3" id="file-upload" type="file" name="filename" 
          ref="myFileInput" @input='validateCSVUpload' accept="text/csv">
        </div>
        <div class="mt-3 bg-grey shadow-md rounded p-4 border border-white "  v-else>
          <p> {{ ___("Invitation|Csv Uploading Message|content") }}</p>
          <p v-if="showCsvMessage" class="text-black font-semibold mt-3"> {{ ___("Invitation|Invitation Job Message|content") }}</p>
        </div>
       

        <div class="mt-5" v-if="showValidatedCSV">
          <h3 class="font-semibold">{{ ___("Invitation|Validated Rows will be invited|content") }}</h3>
          <div class="overflow-x-scroll scrollbar mb-3">
            <table class="border-collapse w-full table-auto">
              <thead>
                <tr>
                  <th v-for="(value, key) in Object.keys(validatedCSV[0])" :key="key" class="p-2 capitalize text-black border border-primary-color table-cell cursor-pointer hover:border-accent-color min-w-10">{{ value }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in validatedCSV" :key="index" class="text-sm lg:text-base shadow-md lg:shadow-none hover:bg-gray-300 bg-white border border-b table-row flex-row flex-no-wrap mb-0 cursor-pointer">
                  <td v-for="(value, key) in item" :key="key" class="w-full lg:w-auto p-2 lg:p-4 text-gray-800 text-center border border-b table-cell relative lg:static">{{ value }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <Btn type="button"  @onClick="inviteCsvUsers" >
            {{ ___("Invitation|Invite accounts|content") }}
          </Btn>
        </div>
        <p v-if="csvError" class="text-red-700 font-semibold mt-3">{{ ___("Invitation|" +csvError +"|content")}}</p>

      </template>
    </Modal>

    <ConfirmationMessage :isAlertShown="isCsvInvitationShown" :alertType="csvinvitationStatus" class="z-20">
      <template v-if="csvinvitationStatus == 'Success'" v-slot:alert>
        {{ ___("Invitation|Csv Invitation Alert|content") }}!
      </template>
      <template v-else v-slot:alert>
        {{ ___("Invitation|Csv Invitation Error Alert|content") }}!
      </template>
      <template v-if="csvinvitationStatus == 'Success'" v-slot:body>
        {{csvinvitationStatusMessage}}
      </template>
      <template v-else v-slot:body>
        {{ ___("Invitation|Csv Invitation Error Body|content") }}
      </template>
    </ConfirmationMessage>

    </div>
</template>

<script>
import Modal from "./Modal.vue";
import Btn from "./Btn.vue";
import ConfirmationMessage from "./ConfirmationMessage.vue";
import axios from "axios";
import FileDownload from "js-file-download";
import Multiselect from "vue-multiselect";

export default {
  components: {
    Modal,
    Btn,
    ConfirmationMessage,
    Multiselect
  },
  data() {
    return {
      showEmployeeModal: false,
      openTab: 1,
      form: {
        firstname: "",
        lastname: "",
        jobposition: "",
        email: "",
        account_type:'sub_account'
      },
      toggleValue:false,
      errors: [],
      valueChanged : false,
      isemailvalid:false,
      isAlertShown: false,
      invitationStatus:'',
      validEmails:[],
      valueChangedPerson : false,
      changedSubAccounts:[],
      changedPersonAccounts:[],
      isResendInvitationShown: false,
      resendinvitationStatus:'',
      showCsvModal: false,
      selectedCSVType:'subAccount',
      csvFileUpload:null,
      validatedCSV:[],
      showValidatedCSV:false,
      csvError:'',
      csvinvitationStatus:'',
      csvinvitationStatusMessage:'',
      isCsvInvitationShown: false,
      showCsvMessage: false,
      disableSubaccountCsvUpload : false,
      disablePersonaccountCsvUpload : false,
      formData: {},
      customAttributeForm:[]
    };
  },
  methods: {
    toggleEmployeeModal() {
      this.showEmployeeModal = !this.showEmployeeModal;
    },
    toggleTabs(tabNumber) {
      this.openTab = tabNumber;
    },
    clearForm() {
      this.form.firstname = this.form.lastname =this.form.jobposition = this.form.email= "";
      this.errors=[];
    },
    inviteAccount() {
      this.errors = [];
      if (!this.form.firstname) this.errors.push(this.___("Invitation|Fill first name|content"));
      if (!this.form.lastname) this.errors.push(this.___("Invitation|Fill last name|content"));
      if(this.form.account_type =='sub_account'){
        if (!this.form.jobposition) this.errors.push(this.___("Invitation|Fill job position|content"));
      }
      if (!this.form.email) this.errors.push(this.___("Invitation|Fill Email|content"));

      if(this.form.account_type =='sub_account' && (this.form.firstname && this.form.lastname && this.form.email && this.isemailvalid && this.form.jobposition)){

        let data = {
          form: this.form,
          mainAccountId: this.$page.props.mainAccountId,
        };
        this.$inertia.post("/inviteaccount", data,
          {
            onSuccess: () => {
              if(this.$page.props.flash == 'Success'){
                this.clearForm();
              }
              return Promise.all([
              this.invitationStatus = this.$page.props.flash,
              this.isAlertShown = !this.isAlertShown,
              setTimeout(() => {
                this.isAlertShown = !this.isAlertShown;
              }, 3000),

            ]);
            }
          });
      }
      else if(this.form.account_type =='person_account' && (this.form.firstname && this.form.lastname && this.form.email && this.isemailvalid)){
        let data = {
          form: this.form,
          mainAccountId: this.$page.props.mainAccountId,
          customAttributes : this.customAttributeForm
        };
        this.$inertia.post("/inviteaccount", data,
          {
            onSuccess: () => {
              if(this.$page.props.flash == 'Success'){
                this.clearForm();

                this.customAttributeForm.forEach((att)=>{
                  if (att.attributeType == 'BOOLEAN') {
                      att.booleanValue = false;
                    }
                    else if (att.attributeType == 'STRING' || att.attributeType == 'LARGE_TEXT' || att.attributeType == 'URL' ) {
                      att.stringValue = "";
                    }
                    else if (att.attributeType == 'DECIMAL' || att.attributeType == 'INTEGER') {
                      att.numberValue = "";
                    }
                    else if (att.attributeType == 'LIST') {
                        att.selectableValues = att.selectableValues
                        att.selectedValueId = "";
                    }
                    else if (att.attributeType == 'MULTISELECT_LIST') {
                        att.selectableValues = att.selectableValues
                        att.selectedValues = [];
                    }
                    else if (att.attributeType == 'DATE'){
                      att.dateValue = null;
                    }
                })

              }
              return Promise.all([
              this.invitationStatus = this.$page.props.flash,
              this.isAlertShown = !this.isAlertShown,
              setTimeout(() => {
                this.isAlertShown = !this.isAlertShown;
              }, 3000),
            ]);
            }
          });
      }
     },
    toggleActivation(item, accountType) {
      item.activated = item.activated === 0 ? 1 : 0;

      if (accountType === 'person_account') {
        const existingItem = this.changedPersonAccounts.find(personAccount => personAccount.id === item.id);
        if (existingItem) {
          Object.assign(existingItem, item);
        } else {
          this.changedPersonAccounts.push(item);
        }
        this.valueChangedPerson = true;
      } else {
        const existingItem = this.changedSubAccounts.find(subAccount => subAccount.id === item.id);
  
        if (existingItem) {
          Object.assign(existingItem, item);
        } else {
          this.changedSubAccounts.push(item);
        }
        this.valueChanged = true;
      }
    },
    toggleHelpdesk(item){
      item.helpdesk_enabled = item.helpdesk_enabled === 0 ? 1 : 0;
      const existingItem = this.changedSubAccounts.find(subAccount => subAccount.id === item.id);
  
      if (existingItem) {
        Object.assign(existingItem, item);
      } else {
        this.changedSubAccounts.push(item);
      }
      this.valueChanged = true;
    },
    toggleView(item,type){
      item[type] = item[type] === 0 ? 1 : 0;

      const existingItem = this.changedSubAccounts.find(subAccount => subAccount.id === item.id);
  
      if (existingItem) {
        Object.assign(existingItem, item);
      } else {
        this.changedSubAccounts.push(item);
      }
      this.valueChanged = true;

    },
    saveChanges(type){
      const requestData = {
        type,
        data: (type === 'sub_account')
          ? this.changedSubAccounts
          : this.changedPersonAccounts
      };

      this.$inertia.post('/changeuseractivations', requestData, {
        onSuccess: () => {
          if (type === 'sub_account') {
            this.valueChanged = false;
            this.changedSubAccounts = [];
          } else if (type === 'person_account') {
            this.valueChangedPerson = false;
            this.changedPersonAccounts=[];
          }
        },
      });
    },
    resendInvitation(account){
      this.$inertia.post("/resendinvitation", account, {
          onSuccess: () => {
            return Promise.all([
              this.resendinvitationStatus = this.$page.props.flash,
              this.isResendInvitationShown = !this.isResendInvitationShown,
              setTimeout(() => {
                this.isResendInvitationShown = !this.isResendInvitationShown;
              }, 3000),
          ]);
          }
        });
    },
    clearJobPostion(){
      this.form.jobposition='';
      this.errors.pop(this.___("Invitation|Fill job position|content"));
    },
    sendPendingInvitationReminder(){
      const data ={
        subAccounts : this.$page.props.userSubAccount,
        personAccounts : this.$page.props.userPersonAccount
      }
      this.$inertia.post('/pendinginvitation',data);
    },
    csvUpload(){
     this.toggleCsvUploadModal();
    },
    toggleCsvUploadModal() {
      this.showCsvModal = !this.showCsvModal;
    },
    downloadTemplate(){
      axios.post("/downloadcsvtemplate", [this.selectedCSVType, this.customAttributeForm]).then((response) => {
        const contentDisposition = response.headers['content-disposition'];
        const match = contentDisposition && contentDisposition.match(/filename="(.+)"/);
        const fileName = match ? match[1] : 'datatable.csv';
        FileDownload(response.data, fileName);
      });
    },
    validateCSVUpload(event){
      this.csvFileUpload = null;
      let file = event.target.files[0];
      this.csvFileUpload = file;

      let formData = new FormData();
      formData.append('csvFile', file);

      axios.post('/validatecsvupload', formData,
        {
          params: {
            csvType: this.selectedCSVType,
            customAttributes : this.customAttributeForm
          }
        }
      )
      .then(response => {
          const responseData = response.data;
          if(responseData.length>0){
            this.csvError = '';
            this.validatedCSV = responseData;
            this.showValidatedCSV = !this.showValidatedCSV;
          }
          else{
            this.csvError = "No valid records";
          }


      })
      .catch(error => {
          if (error.response) {
            this.showValidatedCSV = false;
            this.validatedCSV =[];
            // The request was made, and the server responded with a status code that falls out of the range of 2xx
         
            this.csvError = error.response.data['error'];
          } else if (error.request) {
            // The request was made, but no response was received
            this.showValidatedCSV = false;
            this.validatedCSV =[];
           
            this.csvError = error.request;
          } else {
            // Something happened in setting up the request that triggered an Error
            this.showValidatedCSV = false;
            this.validatedCSV =[];
           
            this.csvError = error.message;
          }
      });

    },
    inviteCsvUsers(){
      this.showCsvMessage = true;
      axios.post('/invitecsvupload', this.validatedCSV,
        {
          params: {
            csvType: this.selectedCSVType,
            mainAccountId: this.$page.props.mainAccountId,
            customAttributes : this.customAttributeForm
          }
        }
      )
      .then(response => {
          // const key = Object.keys(response.data)[0]; // Get the first (and only) key from the object
          // const value = response.data[key];
          
          //   this.csvinvitationStatus = key,
          //   this.csvinvitationStatusMessage = value;
          //   this.isCsvInvitationShown = !this.isCsvInvitationShown,
          //     setTimeout(() => {
          //       this.isCsvInvitationShown = !this.isCsvInvitationShown;
          //     }, 3000)
            
      })
      .catch(error => {
      });

      if(this.selectedCSVType == 'subAccount'){
        this.disableSubaccountCsvUpload = true;
      }
      else{
        this.disablePersonaccountCsvUpload = true;
      }

      this.csvError = '';
      this.validatedCSV = [];
      this.showValidatedCSV = false;
    },
    updateCsvType(){
      this.validatedCSV= [];
      this.showValidatedCSV = false;
      this.csvError = '';
      
      if(this.$refs.myFileInput){
        this.$refs.myFileInput.value = '';
      }
    },
    getCustomAttributeValue(customAttributes,targetId){
      const result = customAttributes.find(item => item.attributeDefinitionId === targetId);

      const resultValue = result ? 
      Object.keys(result).length === 1 && result.attributeDefinitionId ? 
        '-' :
        Object.values(result).find((value, index) => {
          const key = Object.keys(result)[index];
          return key !== "attributeDefinitionId";
        }) 
      : '-';

      return resultValue;
    },
    findLabelLang(attributeLabels,defaultLabel){
      let userLang = this.$page.props.user['language'];
      const foundLabel = attributeLabels.find(function(item) {
        return item.locale === userLang;
      });

      if(foundLabel){
        return foundLabel['labelText'];
      }
      else{
        return defaultLabel;
      }
    },
    valueString(array) {
      if (!array || array.length === 0) {
        return '';
      }
      return array.map(item => item.value).join(',');
    },
  },
  computed:{
    emailCheck(){
      let myemail =  this.form.email;
      let user  = this.$page.props.user;
      let alldomains = this.$page.props.accountDomains.includes('*');

      if(!user['allow_other_domains']){
        if(!this.validEmails.includes(user['default_domain'])){
          this.validEmails.push(user['default_domain']);
        }
      }
      else{
        if(alldomains && !this.validEmails.includes('*') && !this.validEmails.includes(this.___("Invitation|All Domains Allowed|content"))){
          this.validEmails.push(this.___("Invitation|All Domains Allowed|content"));
        }
        else if(!alldomains){
          if(!this.validEmails.includes(user['default_domain'])){
            this.validEmails.push(user['default_domain']);
          }
          this.$page.props.accountDomains.forEach(element => {
              if(!this.validEmails.includes(element)){
                this.validEmails.push(element);
              }
          });
        }
      }

      if(user['allow_invitation'] == true && user['allow_other_domains']== false  && user['default_domain'] == myemail.split('@')[1]){
        this.isemailvalid = true;
      }
      else if (user['allow_invitation'] == true && user['allow_other_domains']== true && alldomains){
        this.isemailvalid = true;
      }
      else if(user['allow_invitation'] == true && user['allow_other_domains']== true && (this.$page.props.accountDomains.includes(myemail.split('@')[1]) || user['default_domain'] == myemail.split('@')[1])){
        this.isemailvalid = true;
      }
      else{
        this.isemailvalid = false;
      }
    },
    isUploadEnabled(){
      let user  = this.$page.props.user;

      if(this.selectedCSVType == 'subAccount' && (this.disableSubaccountCsvUpload || user['subaccounts_invited'])){
        return false;
      }
      else if(this.selectedCSVType == 'personAccount' && (this.disablePersonaccountCsvUpload || user['personaccounts_invited'])){
        return false;
      }
      else return true;
      
    },
  },
  mounted(){
    let customAttributes = this.$page.props.invitationAdditionalAttributesList;

    if (customAttributes && customAttributes.length > 0) {
        customAttributes.forEach((customAttribute) => {
          let myObject = {
                    attributeDefinitionId: customAttribute.id,
                    label: this.findLabelLang(customAttribute.attributeLabels, customAttribute.label),
                    attributeType: customAttribute.attributeType,
                };

            if (customAttribute.attributeType == 'BOOLEAN') {
              myObject.booleanValue = false;
            }
            else if (customAttribute.attributeType == 'STRING' || customAttribute.attributeType == 'LARGE_TEXT' || customAttribute.attributeType == 'URL' ) {
              myObject.stringValue = "";
            }
            else if (customAttribute.attributeType == 'DECIMAL' || customAttribute.attributeType == 'INTEGER') {
              myObject.numberValue = "";
            }
            else if (customAttribute.attributeType == 'LIST') {
                myObject.selectableValues = customAttribute.selectableValues
                myObject.selectedValueId = "";
            }
            else if (customAttribute.attributeType == 'MULTISELECT_LIST') {
                myObject.selectableValues = customAttribute.selectableValues
                myObject.selectedValues = [];
            }
            else if (customAttribute.attributeType == 'DATE'){
              myObject.dateValue = null;
            }

            this.customAttributeForm.push(myObject);
        });
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>